import React from "react";

import workPassportRequirementsModelLiveRelationshipDesktop from "../../images/work-passport-requirements-model-live-relationship-desktop.svg";
import workPassportRequirementsModelLiveRelationshipMobile from "../../images/work-passport-requirements-model-live-relationship-mobile.svg";

import "./WorkPassportRequirementsModel.css";

export default function WorkPassportRequirementsModel() {
  return (
    <section
      className="work-passport-requirements-model"
      id="work-passport-requirements-model"
      aria-labelledby="work-passport-requirements-model-title"
    >
      <div className="work-passport-requirements-model__inner">
        <header className="work-passport-requirements-model__header">
          <p className="work-passport-requirements-model__eyebrow">
            <span aria-hidden="true" />
            One live compliance model
          </p>

          <div className="work-passport-requirements-model__heading-grid">
            <h2 id="work-passport-requirements-model-title">
              Every requirement, mapped to the work.
            </h2>
            <p>
              Work Passport creates a live relationship between each site,
              position, requirement and employee assigned to perform the work.
            </p>
          </div>
        </header>

        <picture className="work-passport-requirements-model__visual">
          <source
            media="(max-width: 620px)"
            srcSet={workPassportRequirementsModelLiveRelationshipMobile}
          />
          <img
            src={workPassportRequirementsModelLiveRelationshipDesktop}
            alt="Site, position, requirements, employee and validity combining into a live deployment readiness result"
          />
        </picture>

        <p className="work-passport-requirements-model__note">
          <span aria-hidden="true" />
          A change to any input recalculates readiness.
        </p>
      </div>
    </section>
  );
}
